module.exports = __webpack_public_path__ + "static/media/ui-reviewer-assignment.8674066f.png";